import React from 'react';
import { Typography } from 'antd';
import dayjs from 'dayjs';
import classNames from 'classnames';
import { ColumnsType } from 'antd/es/table/interface';
import styles from './styles.module.pcss';

interface ColumnStyleProps {
  fontSize?: string;
  fontWeight?: string;
  color?: string;
}

const createColumn = <T, K extends keyof T>({
  key,
  title,
  align = 'left',
  sorter,
  width,
  customStyles,
  format,
  render,
  defaultSortOrder,
  sortDirections = ['ascend', 'descend'],
  ellipsis = false,
}: Omit<ColumnsType<T>[number], 'title'> & {
  key: K;
  dataIndex?: K;
  title: string;
  sortable?: boolean;
  customStyles?: ColumnStyleProps;
  format?: string;
}) => ({
  key,
  dataIndex: key,
  title: (
    <Typography.Text
      strong
      className={styles.columnHeader}
      style={customStyles as React.CSSProperties}
      ellipsis={!ellipsis ? { tooltip: title } : false}
    >
      {title}
    </Typography.Text>
  ),
  align,
  width,
  ellipsis: ellipsis ? { showTitle: true } : false,
  sorter: sorter,
  sortDirections: sorter ? sortDirections : undefined,
  defaultSortOrder,
  render: render || (format ? (value: T[K]) => dayjs(value as string).format(format) : undefined),
  className: classNames(styles.column, {
    [styles.alignLeft]: align === 'left',
    [styles.alignCenter]: align === 'center',
    [styles.alignRight]: align === 'right',
  }),
});

export default createColumn;
